import React, { memo } from 'react';
import { Box } from 'native-base';
import { Typography } from 'fmc-digital-common';
import { kebabCase } from 'lodash';
const NewLoanInProgressHeader = ({
  header
}) => /*#__PURE__*/React.createElement(Box, null, /*#__PURE__*/React.createElement(Typography, {
  variant: "subtitle1",
  fontWeight: 500,
  accessibilityLabel: kebabCase(header),
  accessibilityRole: "text",
  testID: kebabCase(header),
  color: "darkGray.900"
}, header));
export default /*#__PURE__*/memo(NewLoanInProgressHeader);
//# sourceMappingURL=index.js.map